import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { CookiesProvider } from 'react-cookie';
import ReactGA from 'react-ga4';
import { BrowserRouter } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { ThemeProvider } from 'styled-components';
import { Reset } from 'styled-reset';
import AppContent from './pages/AppContent';
import { isDarkModeRecoil } from './recoil/atoms/router/mainRouterRecoil';
import ScrollToTop from './routes/SrollToTop';
import * as S from './styles/Global.styles';
import { darkTheme, theme } from './styles/theme';

const App: React.FC = () => {
  // 높이값 가져오기위함
  function setScreenSize(): void {
    const vh: number = window.innerHeight;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: true,
        retry: (failureCount, error: any) => {
          const status = error.response ? error.response.status : null;
          return status === 401;
        },
      },
      mutations: {
        retry: (failureCount, error: any) => {
          const status = error.response ? error.response.status : null;
          return status === 401;
        },
      },
    },
  });

  // 다크모드 타입
  const isDarkModeS = useRecoilValue(isDarkModeRecoil);

  // 새 버전에 대한 hook
  // const { updateAvailable } = useServiceWorker();

  // 구글 애널리틱스 연결
  useEffect(() => {
    setScreenSize();
    ReactGA.initialize(`${process.env.REACT_APP_GA_ID}`);
  }, []);

  return (
    <CookiesProvider>
      <QueryClientProvider client={queryClient}>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        <ThemeProvider theme={isDarkModeS === 'darkTheme' ? darkTheme : theme}>
          <S.Container>
            <Reset />
            <S.GlobalStyle />
            <BrowserRouter>
              <ScrollToTop /> {/* 페이지 이동시 스크롤 상단으로 이동 */}
              {/* {updateAvailable && <UpdateAvailablePage updateAvailable={updateAvailable} />} */}
              <AppContent />
            </BrowserRouter>
          </S.Container>
        </ThemeProvider>
      </QueryClientProvider>
    </CookiesProvider>
  );
};

export default App;
